import type React from 'react';
import { useState } from 'react';
import { KovResourcePicker, Modal } from '@kathondvla/react-shared-components/src/components';
import { escapeRegExp } from 'lodash';
import type { Content, ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { useSelector } from 'react-redux';
import {
  isLlinkidOdetLoading,
  selectFormattedOdetChildren,
  selectLlinkidOdetCurriculum,
} from '@UI/aside/asideGoalRelations/asideGoalRelationsSelectors';

export interface LlinkidGoalOdetEndTermReferencesModalProps {
  selectedValues?: string[];
  onClose?: () => void;
  onSubmit?: (response: { goalHref: ContentHref }) => void;
}

const LlinkidGoalOdetEndTermReferencesModal: React.FC<
  LlinkidGoalOdetEndTermReferencesModalProps
> = ({ selectedValues, onClose = () => {}, onSubmit }) => {
  const [selectedGoal, setSelectedGoal] = useState<Content | undefined>();
  const isLoading = useSelector((state: RootState) => isLlinkidOdetLoading(state));
  const llinkidOdetCurriculum = useSelector((state: RootState) =>
    selectLlinkidOdetCurriculum(state),
  );
  const nonSelectedOdetGoals = useSelector((state: RootState) =>
    selectFormattedOdetChildren(state, selectedValues),
  );

  const onSelectGoalOdet = (value: Content) => {
    setSelectedGoal(value);
  };

  const handleSubmit = () => {
    if (onSubmit && selectedGoal) {
      onSubmit({
        goalHref: selectedGoal.$$meta.permalink,
      });
    }
    onClose();
  };

  const filterData = ({ data }, str) => {
    if (!str || str.trim().length === 0) {
      return true;
    }
    const regExp = new RegExp(escapeRegExp(str), 'gi');
    return regExp.test(data.displayName);
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title={'Gerelateerde doelen basisgeletterdheid'} onClose={onClose} />
      <Modal.Body>
        {isLoading && <div className="shimmer narrowLine" />}
        {!isLoading && (
          <div style={{ paddingBottom: '36px' }}>
            <div className="form-group">
              <div className="row">
                <div className="col-md-2">
                  <label className="control-label control-label-inline">Document:</label>
                </div>
                <div className="col-md-10">
                  <label className="control-label control-label-inline">
                    <span style={{ fontStyle: 'italic', color: '#666' }}>
                      {llinkidOdetCurriculum?.title}
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div style={{ paddingLeft: '10px' }}>
                <label className="control-label control-label-inline">Gerelateerd doel:</label>
              </div>
              <div className="col-md-12">
                <KovResourcePicker
                  defaultValue={selectedGoal}
                  localData={nonSelectedOdetGoals}
                  filter={filterData}
                  disabled={nonSelectedOdetGoals.length === 0}
                  placeholder="Kies een gerelateerd doel"
                  display={(o) => o.displayName}
                  optionTemplate={(o) => (
                    <span dangerouslySetInnerHTML={{ __html: o.displayName }} />
                  )}
                  clearable={true}
                  disableSearch={false}
                  menuPlacement="bottom"
                  onChange={onSelectGoalOdet}
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit} disabled={!selectedGoal}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

LlinkidGoalOdetEndTermReferencesModal.displayName = 'LlinkidGoalOdetEndTermReferencesModal';

export default LlinkidGoalOdetEndTermReferencesModal;
